import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { AutoFormattedMessage } from '@pcid/string-utils';
import { getRelyingPartyStorage } from '@pcid/storage-utils';
import { getStoreName } from '../config-context';

const Breadcrumb = ({ relyingParty = getRelyingPartyStorage().get(), className }) => (
	getStoreName(relyingParty)
		? (
			<div className={classNames('breadcrumb', className)}>
				<AutoFormattedMessage
					id="common.toContinueTo"
					values={{ storeName: <AutoFormattedMessage id={getStoreName(relyingParty)} /> }}
				/>
			</div>
		)
		: null
);

Breadcrumb.propTypes = {
	relyingParty: PropTypes.string,
	className: PropTypes.string,
};

export default (Breadcrumb);
